import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import "./SalonLocation.scss";

const SALON_POSITION = { lat: 13.113159, lng: 80.228722 };

const HOURS = [
  { days: "Mon – Sat", time: "9:00 AM – 8:00 PM" },
  { days: "Sunday",    time: "10:00 AM – 6:00 PM" },
];

const SalonLocation = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || "AIzaSyB5029BBkp5eiQeA8Ffdj5TUm3yrQhbXr4",
  });

  return (
    <section className="location" aria-label="Salon Location">
      <div className="location__info">
        <span className="location__kicker">Find Us</span>
        <h2 className="location__title">Visit Priyaa's Salon</h2>
        <div className="location__divider" />

        <div className="location__detail">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
            <circle cx="12" cy="9" r="2.5"/>
          </svg>
          <p>29/9, 1st Main Rd, Jawahar Nagar,<br />Perambur, Chennai – 600082</p>
        </div>

        <div className="location__detail">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <rect x="3" y="4" width="18" height="18" rx="2"/>
            <path d="M16 2v4M8 2v4M3 10h18"/>
          </svg>
          <div className="location__hours">
            {HOURS.map(h => (
              <div key={h.days} className="location__hours-row">
                <span>{h.days}</span><span>{h.time}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="location__actions">
          <a
            href="https://maps.app.goo.gl/mVv7rc22jbXsiMUN9"
            target="_blank"
            rel="noreferrer"
            className="location__btn location__btn--directions"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M3 12l18-9-9 18-2-8-7-1z"/>
            </svg>
            Get Directions
          </a>
          <a
            href="https://wa.me/919999999999?text=Hi%2C%20I'd%20like%20to%20book%20an%20appointment%20at%20Priyaa's%20Beauty%20Salon"
            target="_blank"
            rel="noreferrer"
            className="location__btn location__btn--whatsapp"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.557 4.126 1.532 5.862L.054 23.454a.5.5 0 0 0 .492.546.5.5 0 0 0 .146-.022l5.798-1.537A11.944 11.944 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.89 0-3.66-.5-5.19-1.369l-.371-.217-3.844 1.018 1.034-3.741-.228-.375A9.972 9.972 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
            </svg>
            WhatsApp Us
          </a>
        </div>
      </div>

      <div className="location__map">
        {isLoaded ? (
          <GoogleMap
            center={SALON_POSITION}
            zoom={16}
            mapContainerClassName="location__map-container"
            options={{ disableDefaultUI: true, zoomControl: true, styles: mapStyles }}
          >
            <Marker position={SALON_POSITION} />
          </GoogleMap>
        ) : (
          <div className="location__map-loading">Loading map…</div>
        )}
      </div>
    </section>
  );
};

const mapStyles = [
  { elementType: "geometry", stylers: [{ color: "#1a0d1a" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#1a0d1a" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#c0a0ba" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#2e1a2e" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#1a0d1a" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#4a2040" }] },
  { featureType: "poi", elementType: "geometry", stylers: [{ color: "#221422" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#0d0a1a" }] },
  { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2a1525" }] },
];

export default SalonLocation;
